// src/AdminDashboard.js
import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

function AdminDashboard() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminUser");
    navigate("/admin/login");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Admin Dashboard</h1>
      <p>Welcome to the admin area. Use the links below to manage your application.</p>
      <nav>
        <ul>
          <li><Link to="/admin/challenges">Manage Challenges</Link></li>
          <li><Link to="/admin/products">Manage Products</Link></li>
          <li><Link to="/admin/purchases">View Purchases</Link></li>
          {/* You can add more admin links here */}
        </ul>
      </nav>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default AdminDashboard;